import { defineMessages } from 'react-intl';

export default defineMessages({
	tryAgain: {
		id: 'purchase.checkoutSessions.tryAgain',
		defaultMessage: 'Try again',
		description: 'Button to re-attempt loading the payment form after a checkout-session load error',
	},
	// Terminal "processing" state copy. Default wording is a sensible placeholder —
	// design/PM may refine it; the required behavior is a reassuring message + an explicit exit
	// (no permanently-disabled button).
	processingPending: {
		id: 'purchase.checkoutSessions.processingPending',
		defaultMessage: 'Your payment was received. We’re confirming your subscription — this can take a moment.',
		description:
			'Terminal message shown when payment succeeded but the subscription is still being provisioned (fulfillment lagged past the poll window)',
	},
	processingDone: {
		id: 'purchase.checkoutSessions.processingDone',
		defaultMessage: 'Got it',
		description: 'Button that acknowledges the processing message and closes the payment form / modal',
	},
	providerError: {
		id: 'purchase.checkoutSessions.providerError',
		defaultMessage: 'We couldn’t load the payment form. Please try again.',
		description: 'Error shown when the payment form (checkout session) fails to load',
	},
	confirmError: {
		id: 'purchase.checkoutSessions.confirmError',
		defaultMessage: 'We couldn’t complete your payment. Please try again.',
		description: 'Generic fallback error shown when a payment confirmation fails without a specific message',
	},
	updatingPaymentForm: {
		id: 'purchase.checkoutSessions.updatingPaymentForm',
		defaultMessage: 'Updating the payment form',
		description:
			'Screen-reader announcement (Loader announcement prop, not visible text) while a plan/coupon/promo change is loading its replacement session over the still-usable previous payment form',
	},
	updatePaymentFormFailed: {
		id: 'purchase.checkoutSessions.updatePaymentFormFailed',
		defaultMessage: 'We couldn’t update the payment form for your new selection. Please try again.',
		description:
			'Overlay error shown in place of the loading state when the background session create for a plan/coupon/promo change fails',
	},
});
